document.addEventListener('DOMContentLoaded', () => {
    let autocomplete = window.algoliaShopify.externals.autocomplete;
    let getAlgoliaResults = window.algoliaShopify.externals.getAlgoliaResults;
    let algoliasearch = window.algoliaShopify.externals.algoliasearch;

    const searchClient = algoliasearch(
    'U9447UQ9RN',
    '762b917c9009a70b3de00cf3491025a8'
    );

    const autocompleteBlog = autocomplete({
        container: '#blog-search-form',
        placeholder: 'Search for articles',
        getSources({ query }) {
            return [
                {
                    sourceId: 'articles',
                    getItems() {
                    return getAlgoliaResults({
                        searchClient,
                        queries: [
                            {
                                indexName: 'shopify_articles',
                                query,
                                params: {
                                    hitsPerPage: 5,
                                },
                            },
                        ],
                    });
                    },
                    templates: {
                        item({ item, components, html }) {
                            return html`<div class="aa-ItemWrapper">
                                <a class="aa-ItemContent" href="/blogs/${item.blog.handle}/${item.handle}">
                                    <div class="aa-ItemIcon aa-ItemIcon--alignTop">
                                        <img
                                            src="${item.image}"
                                            alt="${item.title}"
                                            width="40"
                                            height="40"
                                        />
                                    </div>
                                    <div class="aa-ItemContentBody">
                                        <div class="aa-ItemContentTitle">
                                            ${components.Highlight({
                                                hit: item,
                                                attribute: 'title',
                                            })}
                                        </div>
                                    </div>
                                </a>
                            </div>`;
                        },
                    },
                },
            ];
        },
    });

    document.addEventListener('click', (event) => {
        const clickInsideAutocomplete = event.target.closest('.aa-Autocomplete');
        if (!clickInsideAutocomplete) {
            autocompleteBlog.setIsOpen(false);
        }
    });
});